export default __webpack_public_path__ + "media/images/favicon/apple-touch-icon-6b673c8728ee5c6a9e1dacaccf099786.png";